import React from 'react';
import { 
  Shield, 
  MapPin, 
  User, 
  Calendar, 
  Lock, 
  Key, 
  AlertTriangle,
  Check
} from 'lucide-react';

/**
 * Компонент боковой панели с советами по приватности EXIF-данных
 */
const PrivacyTipsSidebar = () => {
  const tips = [
    {
      icon: MapPin,
      title: 'Геолокация',
      description: 'Отключите функцию геотегинга в настройках вашей камеры или смартфона для защиты от отслеживания вашего местоположения.',
      risk: 'Высокий'
    },
    {
      icon: User,
      title: 'Личные данные',
      description: 'Не указывайте реальное имя в метаданных автора, если планируете публиковать фотографии в открытом доступе.',
      risk: 'Средний'
    },
    {
      icon: Calendar,
      title: 'Временные метки',
      description: 'Временные метки могут раскрыть ваши повседневные маршруты и привычки, особенно при публикации регулярных фотографий.',
      risk: 'Средний'
    },
    {
      icon: Key,
      title: 'Серийные номера',
      description: 'Удаляйте серийные номера камеры и объектива из метаданных, чтобы защитить ваше оборудование от идентификации.',
      risk: 'Низкий'
    },
    {
      icon: Lock,
      title: 'Проверка перед публикацией',
      description: 'Всегда проверяйте EXIF-данные перед публикацией фотографий в интернете, особенно если они сделаны дома или на работе.',
      risk: 'Общая рекомендация'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Shield className="w-5 h-5 mr-2 text-purple-500" />
        Советы по защите приватности
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className={`flex items-start space-x-3 p-3 rounded-lg border ${
              tip.risk === 'Высокий' 
                ? 'bg-red-50 dark:bg-red-900/20 border-red-100 dark:border-red-800'
                : tip.risk === 'Средний'
                  ? 'bg-amber-50 dark:bg-amber-900/20 border-amber-100 dark:border-amber-800'
                  : 'bg-gray-50 dark:bg-gray-700/30 border-gray-200 dark:border-gray-700'
            } hover:bg-opacity-80 dark:hover:bg-opacity-90 transition-colors`}
          >
            <tip.icon className="w-5 h-5 text-purple-500 mt-1 flex-shrink-0" />
            <div>
              <div className="flex items-center">
                <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                  {tip.title}
                </h4>
                {tip.risk !== 'Общая рекомендация' && (
                  <span className={`ml-2 inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium ${
                    tip.risk === 'Высокий' 
                      ? 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300'
                      : tip.risk === 'Средний'
                        ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300'
                        : 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300'
                  }`}>
                    {tip.risk}
                  </span>
                )}
              </div>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Check className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-green-700 dark:text-green-300 mb-2">
              Российское законодательство
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400 mb-3">
              В соответствии с ФЗ "О персональных данных" (№152-ФЗ), геолокационные данные и другие метаданные, 
              которые могут идентифицировать физическое лицо, считаются персональными данными и подлежат защите.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyTipsSidebar;